export default "__VITE_ASSET__OHU7xjZ7__"